import { RouterModule, Routes } from '@angular/router';

import { AppLayoutComponent } from './shared/layout/app-layout/app-layout.component';
import { AppSelectionComponent } from './app-selection/app-selection.component';
import { AuthComponent } from './components/auth/auth.component';
import { AuthGuardService } from './services/auth-guard.service';
import { CanDeactivateGuard } from './services/candeactivate-guard.service';
import { ComingSoonRegistrationComponent } from './app-selection/coming-soon-registration.component';
import { ComingSoonReportComponent } from './app-selection/coming-soon-report.component';
import { ErrorPageComponent } from './shared/error-page/error-page.component';
import { LocalUriGuardService } from './services/local-uri-guard.service';
import { LoginLayoutComponent } from './shared/layout/login-layout/login-layout.component';
import { NavbarComponent } from './shared/layout/navbar/navbar.component';
import { NgModule } from '@angular/core';
import { NotificationComponent } from 'src/app/shared/notification/notification.component';
import { SelectProfileComponent } from 'src/app/components/select-profile/select-profile.component';
import { WelcomeComponent } from './app-selection/welcome.component';

const routes: Routes = [
  {
    path: '', component: LoginLayoutComponent,
    children: [
      {
        path: '', component: SelectProfileComponent,
        canActivate: [AuthGuardService],
        canDeactivate: [CanDeactivateGuard]
      }
    ]
  },
  {
    path: '', component: AppLayoutComponent,
    children: [
      {
        path: 'patient',
        loadChildren: () => import('./patients/patients.module').then(m => m.PatientsModule),
        canActivate: [AuthGuardService]
      },
      {
        path: 'facilities',
        loadChildren: () => import('./facilities/facilities.module').then(m => m.FacilitiesModule),
        canActivate: [AuthGuardService]
      },
      {
        path: 'entry', loadChildren: () => import('./entries/entries.module').then(m => m.EntriesModule),
        canActivate: [AuthGuardService]
      },
      {
        path: 'dashboard', loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
        canActivate: [AuthGuardService]
      },
      {
        path: 'support', loadChildren: () => import('./support/support.module').then(m => m.SupportModule),
        canActivate: [AuthGuardService]
      },
      {
        path: 'administration', loadChildren: () => import('./administration/administration.module').then(m => m.AdministrationModule),
        canActivate: [AuthGuardService]
      }
    ]
  },
  { path: 'login', component: AuthComponent },
  { path: 'style-guide', loadChildren: () => import('./style-guide/style-guide.module').then(m => m.StyleGuideModule) },
  { path: 'error', component: NotificationComponent },
  { path: 'welcome', component: WelcomeComponent},
  { path: 'app-selection', component: AppSelectionComponent},
  { path: 'report-app', component: ComingSoonReportComponent},
  { path: 'registration-app', component: ComingSoonRegistrationComponent},
  { path: '**', pathMatch: 'full', component: ErrorPageComponent, canActivate: [LocalUriGuardService]}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
